import { Typography, styled } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import {
  BottomActionArea,
  BottomActionButton,
  FormBody,
  FormContentContainer,
  FormHeader,
} from "@components";
import { Routes } from "@utils";

const StyledCheckCircleIcon = styled(CheckCircleIcon)(({ theme }) => ({
  fontSize: "80px",
  color: theme.palette.success.main,
  marginBottom: "24px",
}));

/**
 * Last screen of the signature migration: BPO validated the doctor, who goes
 * back to signing as before. No PIN is created here; the BPO certificate comes
 * with their next signature. Only the title: nothing changes for the doctor,
 * so there is nothing else to tell them.
 */
export function SignatureMigrationValidated() {
  const navigate = useNavigate();
  return (
    <>
      <FormHeader useMekiDocIcon />
      <FormContentContainer disableGutters>
        <FormBody>
          <StyledCheckCircleIcon />
          <Typography variant="h5" fontWeight={"semibold"}>
            Identidad verificada
          </Typography>
          <BottomActionArea>
            <BottomActionButton onClick={() => navigate(Routes.SOLICITUDES)}>
              Volver
            </BottomActionButton>
          </BottomActionArea>
        </FormBody>
      </FormContentContainer>
    </>
  );
}
